<template>
  <div class="emoji modal-content">
    <div class="box">
      <header class="title is-5">Insert Spacial Chars</header>
      <div class="container emoji__container">
        <picker
          :data="emojiIndex"
          title="Pick your emoji…"
          emoji="point_up"
          :native="true"
          @select="addEmoji"
        />
      </div>
    </div>
  </div>
</template>

<script>
import data from 'emoji-mart-vue-fast/data/all.json';
import { Picker, EmojiIndex } from 'emoji-mart-vue-fast';

const EmojiSelectorModal = {
  computed: {
    emojiIndex() {
      return new EmojiIndex(data);
    }
  },
  methods: {
    async addEmoji(emoji) {
      this.$emit('input', emoji.native);
      this.$emit('close');
    }
  },
  components: {
    Picker
  }
};

export default EmojiSelectorModal;
export function getEmoji(parent) {
  return new Promise((resolve, reject) => {
    parent.$buefy.modal.open({
      parent,
      component: EmojiSelectorModal,
      hasModalCard: true,
      events: {
        input: resolve
      },
      onCancel: reject
    });
  });
}
</script>

<style lang="scss" scoped>
@import '~emoji-mart-vue-fast/css/emoji-mart.css';
@import '~bulma/sass/utilities/mixins.sass';

.emoji {
  width: auto;

  &__container {
    max-width: 33.6rem;
    .button.is-medium {
      font-size: 1rem;
      margin: 0 0 0.1rem 0.1rem;
    }
    @include tablet {
      min-width: 20rem;
    }
  }
}
</style>
